// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"142":"dc67d491","294":"dc1cbfa9"}[chunkId] + ".chunk.js";
};